import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetAllBankAccount(isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetAllBankAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringFinance() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetMerchantMonitoringFinance(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/SetMerchantMonitoringFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringFinanceByFinanceIdList(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinanceByFinanceIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetUnreceivedCheque(type) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: type,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetUnreceivedCheque", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoInsertBankAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccount: input.bankAccount,
      isAllowDupplicateBankAccountNumber: input.isAllowDupplicateBankAccountNumber,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/CreateBankAccountOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBankAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccount: input.bankAccount,
      isAllowDupplicateBankAccountNumber: input.isAllowDupplicateBankAccountNumber,
    };
    return API.peakRealTimeAPI.post("/api/Finance/EditBankAccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCurrencyExchangeRatesByDate(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: input.date.ToDateJsonString(),
      currencyCode: input.currencyCode,
    };
    return API.peakAPI
      .post("/api/Finance/GetCurrencyExchangeRatesByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetEwalletProvider() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetEwalletProvider", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestBankAccountCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetSuggestBankAccountCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankReferenceList(language) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: language,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetBankReference", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllCheque() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI.post("/api/Finance/GetAllCheque", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeDetail(chequeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeId: chequeId,
    };
    return API.peakRealTimeAPI.post("/api/Finance/GetChequeDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateFavoriteBankaccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: input.bankAccountId,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
    };
    return API.peakAPI
      .post("/api/Finance/UpdateFavoriteBankaccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteFavoriteBankaccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: input.bankAccountId,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
    };
    return API.peakAPI
      .post("/api/Finance/DeleteFavoriteBankaccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFavoriteBankaccount(paymentInOutFlowTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      paymentInOutFlowTypeId: paymentInOutFlowTypeId,
    };
    return API.peakAPI.post("/api/Finance/GetFavoriteBankaccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateReceivedWht(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      whtId: input.whtId,
      isReceivedWHT: input.isReceivedWht,
      registerWht: input.registerWht,
      paymentInOutFlowType: input.paymentInOutFlowType,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/UpdateIsReceivedWht", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankAccountDetailByBankAccountId(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetBankAccountListByBankAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoTransferPayment(transferPayment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      transferPayment: transferPayment,
    };
    return API.peakRealTimeAPI.post("/api/Payment/TransferPayment", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoVoidTransferPayment(peakPaymentId) {
    let _input = {
      peakPaymentId: peakPaymentId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/VoidTransferPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidPaymentBankStatement(id) {
    return API.peakRealTimeAPI.delete("/api/PaymentBankStatement/" + id, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceCalendarDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      month: input.month,
      year: input.year,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceCalendarFutureDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      month: input.month,
      year: input.year,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarFutureDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceCalendarDashboardDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: input.date,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarDashboardDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceChequeDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI
      .post("/api/Dashboard/GetChequeDashboardSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateChequeDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      cheque: {
        accountNumber: input.accountNumber,
        branchNumber: input.branchNumber,
        id: input.id,
        chequeNumber: input.chequeNumber,
        bankAccountId: input.bankAccountId,
        bankReferenceId: input.bankReferenceId,
        chequeDate: input.chequeDate,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/UpdateChequeDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceivedAndClearingCheque(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      cheque: {
        id: input.id,
        isReceived: input.isReceived,
        bankAccountId: input.bankAccountId,
        recieveDate: input.recieveDate,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/UpdateReceivedAndClearingCheque", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRegisterWithheldtax(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      whtId: input.whtId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRegisterWithheldtaxFromCustomer", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteCheque(searchText) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchText: searchText,
    };
    return API.peakAPI.post("/api/Finance/GetAutoCompleteCheque", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeByIdList(chequeIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeIdList: chequeIdList,
    };
    return API.peakAPI.post("/api/Finance/GetChequeByIdList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeByCodeList(chequeCodeList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeCodeList: chequeCodeList,
    };
    return API.peakAPI.post("/api/Finance/GetChequeByCodeList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoImportPaymentBankStatement(bankStatementsList, isAutoReconciled = false) {
    const input = {
      newBankStatements: bankStatementsList,
      isAutoReconciled,
    };
    return API.peakRealTimeAPI.post("/api/PaymentBankStatement", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCheckingIsDuplicatePaymentBankStatement(bankStatementsList) {
    const input = {
      newBankStatements: bankStatementsList,
    };
    return API.peakRealTimeAPI
      .post("/api/PaymentBankStatement/IsDuplicate", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetBankReconciledById(reconciledGroupId) {
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI.get("/api/BankReconciled/" + reconciledGroupId, { headers }).then((res) => {
      return res;
    });
  },
  DoDeleteBankReconciled(reconciledGroupId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { actionType: "delete" };
    return API.peakRealTimeAPI.delete("/api/BankReconciled/" + reconciledGroupId, { params, headers }).then((res) => {
      return res;
    });
  },
  DoUndoBankReconciled(reconciledGroupId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { actionType: "undo" };

    return API.peakRealTimeAPI.delete("/api/BankReconciled/" + reconciledGroupId, { params, headers }).then((res) => {
      return res;
    });
  },
  DoMakeBankReconciled(_input) {
    const input = {
      amountReconciled: _input.amountReconciled,
      bankAccountId: _input.bankAccountId,
      journalAccountIds: _input.journalAccountIds,
      paymentBankStatementIds: _input.paymentBankStatementIds,
    };

    return API.peakRealTimeAPI.post("/api/BankReconciled", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoMakeBankReconciledByBankAccount(bankAccountId) {
    return API.peakRealTimeAPI
      .post(
        "/api/BankReconciled/AutoMakeingBankReconciled",
        {
          bankAccountId,
        },
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoApproveBankReconciled(bankReconciledId) {
    return API.peakRealTimeAPI
      .put("/api/BankReconciled/" + bankReconciledId + "/Approve", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoApproveBankReconciledAll(bankAccountId) {
    const input = {
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPI
      .post("/api/BankReconciled/ApproveAll", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRemoveBankReconciledAll(bankAccountId) {
    const input = {
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPI.post("/api/BankReconciled/RemoveAll", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetRemarkPeakPayment(peakPaymentId) {
    const input = {
      peakPaymentId: peakPaymentId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRemarkPeakPayment", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRemarkPaymentStatement(paymentStatementId) {
    const input = {
      paymentStatementId: paymentStatementId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRemarkPaymentStatement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllCountBankstatementIsNotReconciled(bankAccountId) {
    const input = {
      data: {
        bankAccountId: bankAccountId,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/BankReconciled/GetAllCountBankstatementIsNotReconciled", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
